<template>
  <b-form-group
    label="Tanım Türü"
    label-for="config_type"
  >
    <validation-provider
      #default="{ errors }"
      name="Tanım Türü"
      rules="required"
    >
      <v-select
        v-model="dataItem.config_type"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Giriniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'PurchaseOfferConfigTypeSelect',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['purchaseOfferConfig/getConfigTypes']
    },
    dataItem() {
      return this.$store.getters['purchaseOfferConfig/dataItem']
    },
  },
  created() {
    localize('tr')
  },

}
</script>
